module.exports = __webpack_public_path__ + "static/media/gitlab-logo-white.aee777cc.svg";